/**
 * Asynchronously loads the SendOffer container (AXHE-3719).
 */

import loadable from 'utils/loadable';

export const SendOffer = loadable(() => import('./index'), {
  fallback: null,
});
